import { render, staticRenderFns } from "./Searchbox.vue?vue&type=template&id=24e4d3bb&"
import script from "./Searchbox.vue?vue&type=script&lang=ts&"
export * from "./Searchbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports